/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_ConfirmInputs */

const en_shared_confirm = /** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

/** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */
const de_shared_confirm = en_shared_confirm;

/** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */
const es_shared_confirm = en_shared_confirm;

/** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */
const fr_shared_confirm = en_shared_confirm;

/** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */
const it_shared_confirm = en_shared_confirm;

/** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */
const pt_br2_shared_confirm = en_shared_confirm;

/** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */
const pl_shared_confirm = en_shared_confirm;

/** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */
const hu_shared_confirm = en_shared_confirm;

/** @type {(inputs: Shared_ConfirmInputs) => LocalizedString} */
const ro_shared_confirm = en_shared_confirm;

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Shared_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_confirm = /** @type {((inputs?: Shared_ConfirmInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_ConfirmInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_confirm(inputs)
	if (locale === "de") return de_shared_confirm(inputs)
	if (locale === "es") return es_shared_confirm(inputs)
	if (locale === "fr") return fr_shared_confirm(inputs)
	if (locale === "it") return it_shared_confirm(inputs)
	if (locale === "pt-BR") return pt_br2_shared_confirm(inputs)
	if (locale === "pl") return pl_shared_confirm(inputs)
	if (locale === "hu") return hu_shared_confirm(inputs)
	return ro_shared_confirm(inputs)
});
export { shared_confirm as "shared.confirm" }